import React from 'react';
import './Wall.css';

const Wall = () => {
    return(
        <div className='wallContainer'>
            <div className='wallBackdrop'>
                <div className='wallBack'>
                    <div className='wallHead'>
                        TakeAStand
                    </div>
                    <div className='wallSubhead'>
                        
                    </div>
                </div>
            </div>
            
        </div>
        
    )
}

export default Wall;